import { motion } from "framer-motion";

const AUDIENCES = [
  { t: "Unsure about the gym?", d: "For those who want to exercise and get stronger, but have never quite felt that the gym is the right place for them." },
  { t: "Exercise hasn't always felt good", d: "For those who find that pain, niggles or recurring injuries keep getting in the way of exercise." },
  { t: "Getting back to what you love", d: "Return to running, sport, dance, trekking or a favourite hobby — stronger and better prepared." },
  { t: "Strength for health", d: "Build muscle, improve metabolic health and invest in a stronger, more capable body for the years ahead." },
  { t: "Chasing a goal", d: "A faster run. A bigger trek. A stronger lift. A return to competition. Whatever your next goal is, train for it with intent." },
  { t: "Just getting started", d: "You don't need to know how to train. You just need to be ready to start." },
];

export default function WhoFor() {
  return (
    <section id="who" className="py-24 lg:py-40 bg-white border-y border-[#1E1E1E]/10" data-testid="who-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.8 }} className="md:col-span-7"
          >
            <div className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]">
              <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
              Who PLST is for
            </div>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1E1E1E] leading-[0.95]">
              If you've ever thought <br />
              <span className="italic font-medium text-[#A67C00]">"training isn't for me,"</span> <br />
              this is the room for you.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }} className="md:col-span-5 text-[#1E1E1E]/70 leading-relaxed"
          >
            PLST is for anyone who wants to become stronger, move better and do more — with the right guidance. Wherever you are today, your program starts from there.
          </motion.p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 border-t border-[#1E1E1E]/10">
          {AUDIENCES.map((a, i) => (
            <motion.div
              key={a.t}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              className="group p-8 lg:p-10 border-b border-r border-[#1E1E1E]/10 hover:bg-[#F5F4EF] transition-colors"
              data-testid={`audience-${i}`}
            >
              <div className="flex items-baseline gap-3">
                <span className="italic font-medium text-2xl text-[#A67C00]">0{i + 1}</span>
                <h3 className="font-display text-xl md:text-2xl text-[#1E1E1E] tracking-tight">{a.t}</h3>
              </div>
              <p className="mt-4 text-sm md:text-[15px] text-[#1E1E1E]/70 leading-relaxed">{a.d}</p>
              <div className="mt-8 h-px w-8 bg-[#1E1E1E]/20 group-hover:w-16 group-hover:bg-[#A67C00] transition-all duration-700" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
